import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { formatNumber, getLocaleNumberSymbol, NumberSymbol } from '@angular/common';
import { TerraNumberPipe } from './TerraNumber.pipe';

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
 */

@Pipe({ name: 'fileSize' })
export class FileSizePipe implements PipeTransform {

  private units: string[] = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB'
  ];

  constructor(@Inject(LOCALE_ID) public locale: string, private numberPipe: TerraNumberPipe) {
    locale = locale || 'en-US';
  }

  transform(bytes: number = 0, precision: number = 2): string {
    let resultWithUnits: string;
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
      resultWithUnits = '?';
    } else {
      let unit = 0;

      while (bytes >= 1024) {
        bytes /= 1024;
        unit++;
      }

      // let resultNoUnits = bytes.toFixed(+ precision);

      const resultNoUnits = this.numberPipe.transform(bytes, precision);
      //  const x = formatNumber(this.parse(value.toString()), this.locale, '1.0-' + fractionSize);

      resultWithUnits = resultNoUnits + ' ' + this.units[unit];
    }
    return resultWithUnits;
  }
}
